import React from 'react';

export default props => <span className="input-group-addon"><i className="fas fa-user"></i></span>


// WEBPACK FOOTER //
// ./src/components/theme/form/input/input-prefix.jsx